import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import * as PropertyValueTypes from 'automation-ui-flow-core/fields/PropertyValueTypes';
import { getPropertyDateDelayFormatOptions, getStaticDateDelayFormatOptions } from 'automation-ui-action-features/actions/delay-until-date/utils/dateDelayFormatOptions';
import { TimeZoneStrategyType } from 'automation-ui-flow-core/fields/time/TimeZoneStrategy';
import { jsx as _jsx } from "react/jsx-runtime";
export default function DelayUntilDateActionSummary({
  actionMetadata,
  flowObjectTypeId
}) {
  const date = actionMetadata.getDate();
  const timeOfDay = actionMetadata.getTimeOfDay();
  const timeZoneStrategy = actionMetadata.getTimeZoneStrategy();
  if (date.getType() === PropertyValueTypes.OBJECT_PROPERTY) {
    const delta = actionMetadata.getTimeDelta().getDelta();
    const propertyOptions = getPropertyDateDelayFormatOptions(actionMetadata, flowObjectTypeId);
    if (delta < 0) {
      if ((timeZoneStrategy === null || timeZoneStrategy === void 0 ? void 0 : timeZoneStrategy.type) === TimeZoneStrategyType.ENROLLED_OBJECT) {
        return /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "automation-ui-action-features.action-features.delay-until-date.summary.before-date-property-in-object-timezone",
          options: propertyOptions
        });
      } else {
        return timeOfDay === null ? /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "automation-ui-action-features.action-features.delay-until-date.summary.before-date-property-datetime",
          options: propertyOptions
        }) : /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "automation-ui-action-features.action-features.delay-until-date.summary.before-date-property",
          options: propertyOptions
        });
      }
    } else if (delta > 0) {
      if ((timeZoneStrategy === null || timeZoneStrategy === void 0 ? void 0 : timeZoneStrategy.type) === TimeZoneStrategyType.ENROLLED_OBJECT) {
        return /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "automation-ui-action-features.action-features.delay-until-date.summary.after-date-property-in-object-timezone",
          options: propertyOptions
        });
      } else {
        return timeOfDay === null ? /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "automation-ui-action-features.action-features.delay-until-date.summary.after-date-property-datetime",
          options: propertyOptions
        }) : /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "automation-ui-action-features.action-features.delay-until-date.summary.after-date-property",
          options: propertyOptions
        });
      }
    } else {
      if ((timeZoneStrategy === null || timeZoneStrategy === void 0 ? void 0 : timeZoneStrategy.type) === TimeZoneStrategyType.ENROLLED_OBJECT) {
        return /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "automation-ui-action-features.action-features.delay-until-date.summary.on-date-property-in-object-timezone",
          options: propertyOptions
        });
      } else {
        return timeOfDay === null ? /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "automation-ui-action-features.action-features.delay-until-date.summary.on-date-property-datetime",
          options: propertyOptions
        }) : /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "automation-ui-action-features.action-features.delay-until-date.summary.on-date-property",
          options: propertyOptions
        });
      }
    }
  } else {
    const staticOptions = getStaticDateDelayFormatOptions(actionMetadata);
    return (timeZoneStrategy === null || timeZoneStrategy === void 0 ? void 0 : timeZoneStrategy.type) === TimeZoneStrategyType.ENROLLED_OBJECT ? /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "automation-ui-action-features.action-features.delay-until-date.summary.on-date-time-in-object-timezone",
      options: staticOptions
    }) : /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "automation-ui-action-features.action-features.delay-until-date.summary.on-date-time",
      options: staticOptions
    });
  }
}